import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M23.6097 13.6095L16.943 20.2762C16.4217 20.7975 15.579 20.7975 15.0577 20.2762L8.391 13.6095C7.86967 13.0882 7.86967 12.2455 8.391 11.7242C8.91233 11.2028 9.755 11.2028 10.2763 11.7242L16.0003 17.4482L21.7243 11.7242C22.2457 11.2028 23.0883 11.2028 23.6097 11.7242C23.8697 11.9842 24.0003 12.3255 24.0003 12.6668C24.0003 13.0082 23.8697 13.3495 23.6097 13.6095Z",
];

export function ArrowDownIcon(props: IconProps) {
  return <Icon paths={PATHS} {...props} />;
}
